import { Component, inject, Inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MAT_SNACK_BAR_DATA, MatSnackBarModule, MatSnackBarRef } from '@angular/material/snack-bar';

@Component({
  selector: 'app-horus-snackbar-status',
  imports: [
    MatIconModule,
    MatButtonModule,
    MatSnackBarModule
  ],
  templateUrl: './horus-snackbar-status.component.html',
  styleUrl: './horus-snackbar-status.component.scss'
})
export class HorusSnackbarStatusComponent {
  snackBarRef = inject(MatSnackBarRef);
  constructor(@Inject(MAT_SNACK_BAR_DATA) public data: any) {}
}
